import CashTxnForm from "../CashTxnForm";

const MoneyOut = () => <CashTxnForm type="out" />;

export default MoneyOut;
